var Vendd = (function (Vendd) {
	'use strict';

	Vendd.Export = (function (Export) {

		Export.Messages = (function (Messages) {

			Messages.GetListingExport = function (response) {

				var messages = [];

				Vendd.MessageBus.VenddMessage.call(this, "Vendd.Export.Messages.GetListingExport", response);
			}
			Messages.GetListingExport.className = "Vendd.Export.Messages.GetListingExport";

			Messages.GetListingExportSuccess = function (response) {

				var messages = [];

				Vendd.MessageBus.VenddMessage.call(this, "Vendd.Export.Messages.GetListingExportSuccess", response);
			}
			Messages.GetListingExportSuccess.className = "Vendd.Export.Messages.GetListingExportSuccess";

			Messages.GetListingExportFailure = function (response) {

				var messages = [];

				Vendd.MessageBus.VenddMessage.call(this, "Vendd.Export.Messages.GetListingExportFailure", response);
			}
			Messages.GetListingExportFailure.className = "Vendd.Export.Messages.GetListingExportFailure";

			return Messages;
		})(Export.Messages || {});

		return Export;

	})(Vendd.Export || {});

	return Vendd;

})(Vendd || {});
